module.exports = __webpack_public_path__ + "static/ring_of_telekinesis-e968ee1a0277326e5b3a189200b7b8dd.jpeg";